import {createRules} from '../../../common/validations/validations'


export enum AddressType {
  DEPARTURE = 1,
  ARRIVAL = 2,
}


export interface AddressModel {
  id: number
  addressTypeId: number
  name: string
  street?: string
  zip: string
  location: string
  isActivated: boolean
  isJourneyValid: boolean
  journeyDistance: number
  journeyDuration: number
  latitude: string
  longitude: string
  placeId: string
  fullAddress: string
}

export interface DescriptionAddressModel extends AddressModel {
  description: string
}

export interface AddressRelationModel {
  addressId: number
  realAddressId: number
  fullAddress: string
  isOrderedAddress: boolean
}

export interface CompactAddressModel {
  addressId: number
  realAddressId: number
  fullAddress: string
  isOrderedAddress: boolean
}

export interface AddressDetailModel {
  id: number
  name: string
  de: string
}


export interface AddressRouteModel {
  id: number
  address1Id: number
  address2Id: number
  journeyDistance: number
  journeyDuration: number
  contactId?: number
  startAt?: string
  ordering?: number
}

export interface ContactAddress {
  id: number
  contactId: number
  addressId: number
  detailId: number
  isHome: boolean
  isActivated: boolean
  description?: string
  ordering?: number
}

export interface ContactAddressRides {
  contactId: number
  addressId: number
  realAddressId: number
  fullAddress: string
  totalRides: number
  isOrderedAddress: boolean
}

// -----------------------------------------------------------------------------
// Rules
export enum RuleField {
  STREET = 'street',
  ZIP = 'zip',
  LOCATION = 'location',
  NAME = 'name',
  DESCRIPTION = 'description',
}

export const ADDR_RULES = createRules<RuleField>([
  {
    field: RuleField.STREET,
    lengthRule: {
      min: 2, max: 100,
      message: '2-100 Zeichen erforderlich.',
    },
    requireRule: {
      required: true,
    },
    genericMessage: '2-100 Zeichen erforderlich.',
  },
  {
    field: RuleField.ZIP,
    lengthRule: {
      min: 4, max: 5,
      message: '4-5 Ziffern erforderlich.',
    },
    regexRule: {
      pattern: /^\d{4,5}$/,
      message: 'Nur 4-5 Ziffern erlaubt.',
    },
    genericMessage: '4-5 Zeichen erforderlich.',
  },
  {
    field: RuleField.LOCATION,
    lengthRule: {
      min: 2, max: 100,
      message: 'Nur 2-100 Zeichen erlaubt.',
    },
    genericMessage: '2-100 Zeichen erforderlich.',
  },
  {
    field: RuleField.NAME,
    lengthRule: {
      min: 0, max: 255,
    },
    requireRule: {
      required: false,
    },
    genericMessage: '0-255 Zeichen erlaubt.',
  },
  {
    field: RuleField.DESCRIPTION,
    lengthRule: {
      min: 0, max: 255,
    },
    requireRule: {
      required: false,
    },
    genericMessage: '0-255 Zeichen erlaubt.',
  },
])
